import type { PolicyType } from '@libs/enums';
import type { ItemAttributes } from '@ps-smart-cp/ppfw-client';
import {
  Characters,
  ItemName,
  Locale,
  WithBlankSearch,
  type WithBlankSearchObject,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  roleCode: string;
  noteCondition: WithBlankSearchObject;
  policies: SelectedPolicy[];
}

interface SelectedPolicy {
  id: number;
  code: string;
  name: string;
  note: string;
  type: PolicyType;
}

interface Record {
  policies: { id: number; name: string; type: string }[];
}

const attributes = {
  noteCondition: WithBlankSearch.of(Characters.preset.freeFormat({ maxLen: 280 })),
} satisfies ItemAttributes<Schema>;

const titleNames = {
  maintenance: ItemName.of([Locale.ja, 'ロールマスタメンテナンス'], [Locale.en, 'Role Master Maintenance']),
  register: ItemName.of([Locale.ja, 'ロールマスタ登録'], [Locale.en, 'Role Master Register']),
  change: ItemName.of([Locale.ja, 'ロールマスタ変更'], [Locale.en, 'Role Master Change']),
  detail: ItemName.of([Locale.ja, 'ロール詳細'], [Locale.en, 'Role Master Detail']),
};

const names = {
  role: ItemName.of([Locale.ja, 'ロール'], [Locale.en, 'Role']),
  policies: ItemName.of([Locale.ja, 'ポリシー'], [Locale.en, 'Policy']),
};

const buttonNames = {
  addPolicy: ItemName.of([Locale.ja, 'ポリシーを追加'], [Locale.en, 'Add policies']),
};

const roleMst = {
  attributes,
  names,
  titleNames,
  buttonNames,
};

interface RoleMst {
  schema: Schema;
  record: Record;
}

interface SelectPolicyPage {
  prev: string;
  current: string;
}

export { roleMst };
export type { RoleMst, SelectedPolicy, SelectPolicyPage };
